var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3326_14183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9828 9.07023L10.4833 11.4327C10.4131 11.7667 10.1441 12.0004 9.82889 12.0004C4.40859 11.9999 0 7.19054 0 1.27726C0 0.93367 0.214178 0.639764 0.520352 0.563592L2.68598 0.0186705C3.00137 -0.0610638 3.32363 0.11753 3.45469 0.443358L4.45414 2.98633C4.57097 3.28586 4.49217 3.63484 4.26121 3.84062L3.10449 4.85383C3.83453 6.47617 5.04367 7.79523 6.53125 8.59211L7.47828 7.33117C7.66494 7.07851 7.98725 6.99109 8.26182 7.12082L10.5929 8.21089C10.8732 8.37179 11.0559 8.72804 10.9828 9.07023Z",
    fill: "#605F5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3326_14183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.18451f93917b9620e8e07f33ceb3fe0e.svg";
export { ForwardRef as ReactComponent };